import axios from 'axios'
import * as enVariables from 'src/config/config'

export async function resendEmail(email: string) {
  let msg = 'Successfully resent the email. Please check your mailbox'
  await axios
    .post(enVariables.API_HOST + '/api/auth/send-email-confirmation', {
      email: email, // user's email
    })
    .catch((error) => {
      msg = error.response.data.error.message
    })

  return msg
}
